import { render, staticRenderFns } from "./staticsCard.vue?vue&type=template&id=3c5d8372&scoped=true"
import script from "./staticsCard.vue?vue&type=script&lang=js"
export * from "./staticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d8372",
  null
  
)

export default component.exports